/* Shared Jaadu Ghar Quick View controller.
   Works with any `dialog.jaadu-quickview` + `[data-quickview-target]` trigger,
   regardless of which section rendered them. */
(function () {
  function initDialog(dialog) {
    if (dialog.dataset.qvInit === 'true') return;
    dialog.dataset.qvInit = 'true';

    var dataEl = dialog.querySelector('[data-qv-variants]');
    var variants;
    try {
      variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    } catch (err) {
      variants = [];
    }

    var idInput = dialog.querySelector('input[name="id"]');
    var priceEl = dialog.querySelector('[data-qv-price]');
    var imgEl = dialog.querySelector('[data-qv-image]');
    var addBtn = dialog.querySelector('.qv-add-btn');
    var addLabel = dialog.querySelector('[data-qv-add-label]');
    var optionGroups = dialog.querySelectorAll('.qv-option');
    var tiles = dialog.querySelectorAll('[data-qv-tile]');

    var galleryCfg = null;
    var galleryEl = dialog.querySelector('[data-qv-gallery]');
    if (galleryEl) {
      try { galleryCfg = JSON.parse(galleryEl.textContent); } catch (err) { galleryCfg = null; }
    }
    var galleryEntries = [];
    if (galleryCfg && galleryCfg.starts) {
      galleryEntries = Object.keys(galleryCfg.starts).map(function (value) {
        return { value: value, idx: galleryCfg.starts[value] };
      }).sort(function (a, b) { return a.idx - b.idx; });
      if (galleryEntries.length < 2) galleryEntries = [];
    }

    function applyGalleryFilter(value) {
      if (!galleryEntries.length || !tiles.length) return;
      var range = null;
      for (var i = 0; i < galleryEntries.length; i++) {
        if (galleryEntries[i].value === value) {
          range = [galleryEntries[i].idx, i + 1 < galleryEntries.length ? galleryEntries[i + 1].idx : tiles.length];
          break;
        }
      }
      var firstVisible = null;
      var selectedVisible = false;
      tiles.forEach(function (tile, idx) {
        var show = !range || (idx >= range[0] && idx < range[1]);
        tile.style.display = show ? '' : 'none';
        if (show && !firstVisible) firstVisible = tile;
        if (show && tile.classList.contains('is-selected')) selectedVisible = true;
      });
      if (!selectedVisible && firstVisible && imgEl) {
        imgEl.src = firstVisible.dataset.imageSrc;
        selectTileBySrc(firstVisible.dataset.imageSrc);
      }
    }

    function selectTileBySrc(src) {
      tiles.forEach(function (tile) {
        tile.classList.toggle('is-selected', tile.dataset.imageSrc === src);
      });
    }

    tiles.forEach(function (tile) {
      tile.addEventListener('click', function () {
        if (imgEl) imgEl.src = tile.dataset.imageSrc;
        selectTileBySrc(tile.dataset.imageSrc);
      });
    });

    var current =
      variants.find(function (v) { return idInput && String(v.id) === idInput.value; }) ||
      variants.find(function (v) { return v.available; }) ||
      variants[0];
    var selected = current ? current.options.slice() : [];

    function renderSelection() {
      optionGroups.forEach(function (group, i) {
        group.querySelectorAll('.qv-option-btn').forEach(function (btn) {
          btn.classList.toggle('is-selected', btn.dataset.qvValue === selected[i]);
        });
      });

      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });

      if (match) {
        if (idInput) {
          idInput.value = match.id;
          idInput.disabled = false;
        }
        if (priceEl) priceEl.textContent = match.price;
        if (imgEl && match.image) {
          imgEl.src = match.image;
          selectTileBySrc(match.image);
        }
        if (match.available) {
          addBtn.removeAttribute('disabled');
          addBtn.removeAttribute('aria-disabled');
          addLabel.textContent = 'Add to Cart';
        } else {
          addBtn.setAttribute('disabled', '');
          addLabel.textContent = 'Sold Out';
        }
      } else {
        addBtn.setAttribute('disabled', '');
        addLabel.textContent = 'Unavailable';
      }

      if (galleryCfg) applyGalleryFilter(selected[galleryCfg.optionIndex]);
    }

    optionGroups.forEach(function (group, i) {
      group.querySelectorAll('.qv-option-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          selected[i] = btn.dataset.qvValue;
          renderSelection();
        });
      });
    });

    // Close shortly after add-to-cart is pressed. The GoKwik side-cart app
    // swallows the button's `click` and the form's `submit` events entirely
    // (verified on the live store), so we hook `pointerdown`/`keydown`, which
    // fire before its interception. When the theme's own cart pipeline is
    // active instead, the cartUpdate subscriber closes the dialog first and
    // this becomes a no-op.
    if (addBtn) {
      var scheduleClose = function () {
        if (addBtn.disabled) return;
        setTimeout(function () {
          if (dialog.open) dialog.close();
        }, 1000);
      };
      addBtn.addEventListener('pointerdown', scheduleClose);
      addBtn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') scheduleClose();
      });
    }

    if (optionGroups.length) renderSelection();

    var closeBtn = dialog.querySelector('[data-qv-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { dialog.close(); });

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });
  }

  function initAll() {
    document.querySelectorAll('dialog.jaadu-quickview').forEach(initDialog);
  }

  // Open triggers via delegation so late-rendered sections work too
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quickview-target]');
    if (!btn) return;
    e.preventDefault();
    var dialog = document.getElementById(btn.dataset.quickviewTarget);
    if (dialog) {
      initDialog(dialog);
      dialog.showModal();
    }
  });

  function onReady() {
    initAll();
    // Close any open quick view once the item is in the cart, so the cart drawer is visible
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        document.querySelectorAll('dialog.jaadu-quickview[open]').forEach(function (dialog) {
          dialog.close();
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
